<div class="content-wrapper table-full-bx">
	<div class="account-settings">
		<div class="row">
			<div class="col-lg-12">
				<div class="ibox ">
					<div class="ibox-body">
						<div class="iboxcontent">
							<h3>Account Settings</h3>
						</div>
						<!-- Account settings  -->
						<div class="row">
							<div class="col-lg-3 col-sm-12">
								<!-- Tabs nav -->
								<div class="nav nav-pills nav-pills-custom pills-custom">
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);"
										routerLink="/account-settings/change-password"> <span class=" ">Change
											password</span> </a>
									<a class="nav-link mb-3 p-3  " href="javascript:void(0);"
										routerLink="/account-settings/notification"> <span
											class=" ">Notifications</span> </a>
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);"
										routerLink="/account-settings/save-card"
										*ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'" hidden> <span class=" ">Saved
											cards</span> </a>
									<a class="nav-link mb-3 p-3 active " href="javascript:void(0);"
										routerLink="/account-settings/inventory-history"
										*ngIf="userDatas?.Recruiter?.userType == 'SUPER_RECRUITER' || (userDatas?.Recruiter?.userType == 'SUB_RECRUITER' && userPermissionData?.viewActivePlans == 1)">
										<span class="">Subscriptions</span> </a>
									<a class="nav-link mb-3 p-3 " href="javascript:void(0);"
										routerLink="/account-settings/billing-address"
										*ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'"> <span
											class=" ">Billing address</span> </a>
									<a class="nav-link mb-3 p-3  " href="javascript:void(0);"
										routerLink="/account-settings/my-templates"
										*ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'"> <span class=" ">My
											templates</span> </a>
								</div>
							</div>
							<div class="col-lg-9 col-sm-12">
								<!-- Tabs content -->
								<div class="tab-content" id="v-pills-tabContent">
									<div class="tab-pane fade  bg-box show active ">
										<div class="flexbox">
											<div class="iboxcontent">
												<h2 class="mainTitle">My Subscriptions</h2>
											</div>
											<div class="input-group-icon input-group-icon-left"
												*ngIf="userDatas?.Recruiter?.userType != 'SUB_RECRUITER'">
												<div class="col-list-right"> <a href="javascript:void(0)"
														routerLink="post-job" class="commonBtn2"
														routerLink="/account-settings/subscription/subscription-plan">Buy
														More</a> </div>
											</div>
										</div>
										<ul class="nav nav-pills job-list mt-5 mb-5">
											<li class="active"> <a
													routerLink="/account-settings/inventory-history">Active Plan</a>
											</li>
											<li><a href="javascript:void(0)"
													routerLink="/account-settings/subscription">Plan History</a> </li>
										</ul>
										<div class="noDataFound"
											*ngIf="subscriptionData == null || subscriptionData == ''">
											<h2>No Records found</h2>
										</div>
										<div class="subscriptionplanouter"
											*ngIf="subscriptionData != null && (subscriptionStats?.subscribePayment > 0 || subscriptionStats?.inventoryPayment > 0 )|| subscriptionStats?.remainingJobPost != null">
											<h4 class="subheading-5">Active Plan</h4>

											<div class="plan-inner bordertop">
												<div class="billingbox">
													<div class="billingboxinner">
														<p><b> Remaining : </b>Concurrent job posts
															{{subscriptionStats?.remainingJobPost}}/{{subscriptionStats?.totalJobPost}}
														</p>
													</div>
													<div class="billingboxinner ms-3">
														<p><b>Resume views :</b>
															{{subscriptionStats?.resumeViews}}/{{subscriptionStats?.totalView}}
														</p>
													</div>
													<div class="billingboxinner ms-3">
														<p><b>Number of clicks :</b>
															{{subscriptionStats?.usedClick}}/{{subscriptionStats?.totalClick}}
														</p>
													</div>
												</div>
											</div>
											<div class="plan-inner-outer"
												*ngFor="let subData of subscriptionData; let i=index;">
												<div class="plan-inner pb-0">
													<div class="plantext">
														<h4>
															{{subData?.planName}}
															<span class="activeplan"
																*ngIf="subscriptionData?.planName">Active Plan</span>
															<p class="para7 on-off"
																*ngIf="subData.autoRenewalCancel == 0 && subData?.isFreePlan!=1">
																<label class="switch">
																	<input type="checkbox"
																		[checked]="subData.isPause==1"
																		(change)="subData.isPause==1"
																		*ngIf="subData.isPause==1" disabled>
																	<span class="slider round"
																		(click)="subscriptionOnOff(subData)"></span>
																</label>
															</p>
														</h4>
														<p>For most businesses with small teams</p>
													</div>
													<div class="billingbox">
														<div class="billingboxinner ">
															<h6>Billing Cycle:</h6>
															<p>{{subData?.validityType == 'month' ? "Monthly" :
																"Yearly"}}</p>
														</div>
														<div class="billingboxinner ms-5">
															<h6>Ends On:</h6>
															<p>{{subData?.isFreePlan!=1?(subData?.expirydate | date : "d/M/YYYY"):'-'}}</p>
														</div>
													</div>
												</div>
												<div class="plan-inner pb-0">
													<div class="plantext">
														<h4 class="mb-5">  Last payment </h4>
														<div class="billingboxinner"> <p>{{subData?.createdAt | date : "d/M/YYYY"}}</p></div> 
													</div>
													<div class="content">
														<div class="progress m-0">
															<div class="progress-bar" role="progressbar"
																aria-label="Basic example"
																[style.width.%]="(100 * subData?.progresBar)/100"
																[attr.aria-valuenow]="subData?.progresBar"
																aria-valuemin="0" aria-valuemax="100">
																<!-- <span class="inside-prgrs">{{progress}} <span *ngIf="progress">%</span></span> -->
															</div>
														</div>
													</div>
													<div class="plantext">
														<h4 class="mb-5"> Upcoming payment</h4>
														<div class="billingboxinner text-right"> <p>{{subData?.isFreePlan!=1?(subData?.expirydate | date : "d/M/YYYY"):'-'}}</p></div> 
													</div>
												</div>
												<div class="plan-inner bordertop">
													<div class="billingbox">
														<div class="billingboxinner">
															<p></p>
														</div>
														<div class="billingboxinner ms-3">
															<p></p>
														</div>
													</div>
													<div class="plantext" *ngIf="subData.autoRenewalCancel == 0 && subData?.isFreePlan!=1"> <a
															class="commonBtn nobk"
															(click)="cancelSubscription(subData)">Cancel
															Subscription</a> </div>
												</div>
											</div>
										</div>
										<div class="subscriptionplanouter" *ngIf="inventoryData != undefined">
											<h4 class="subheading-5">{{inventoryData?.planName}}</h4>
											<div class="plan-inner-outer">
												<div class="plan-inner pb-0">
													<div class="plantext">
														<h4> Number of clicks
															<p class="para7 on-off" hidden>
																<label class="switch">
																	<input type="checkbox"
																		[checked]="userDatas?.Recruiter?.inventoryPayment==1"
																		(change)="userDatas?.Recruiter?.inventoryPayment==1"
																		*ngIf="userDatas?.Recruiter.inventoryPayment ==1"
																		disabled>
																	<span class="slider round"
																		(click)="inventoryOnOff(userDatas?.Recruiter?.inventoryPayment)"></span>
																</label>

															</p>
														</h4>
														<p>Clicks will be counted when a candidate resume is downloaded,
															candidate profile is forwarded or an email is sent</p>
													</div>
													<div class="billingbox width145">
														<div class="billingboxinner">
															<h6>Total clicks:</h6>
															<p>{{inventoryData?.totalClick}}</p>
														</div>

													</div>
												</div>
												<div class="plan-inner bordertop">

													<div class="billingbox">
														<div class="billingboxinner">
															<p><b> Remaining Clicks :</b>{{inventoryData?.totalClick -
																inventoryData?.remainingClick}}
														</div>
														<div class="billingboxinner ms-5">
															<p><b>Vaild Till :</b> {{inventoryData?.expirydate | date :
																"d/M/YYYY"}}</p>
														</div>
													</div>


												</div>

											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>

		</div>
	</div>
</div>